import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal, DatePicker } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  IMG_BASE_URL,
  GetFeeMaster,
  pendingInterviewListAPIURL,
  pendingInterviewListPassFailAPIURL,
  StudentFeeConcession,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const PendingInterviewList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)

  const [loading, setLoading] = useState(false)

  const [confirmChecked, setConfirmChecked] = useState(false)
  const [passLoading, setPassLoading] = useState(false)
  const [failLoading, setFailLoading] = useState(false)
  const [interviewStatus, setInterviewStatus] = useState('')
  const [failReason, setFailReason] = useState('')
  const [saveLoading, setSaveLoading] = useState(false)

  const [concessionChecked, setConcessionChecked] = useState(false)

  const [feeTypes, setFeeTypes] = useState([])
  const [selectedFeeId, setSelectedFeeId] = useState('')
  const [feeAmount, setFeeAmount] = useState(0)
  const [concessionAmount, setConcessionAmount] = useState('')
  const [concessionRemark, setConcessionRemark] = useState('')

  useEffect(() => {
    if (concessionChecked) {
      fetchFeeTypes()
    }
  }, [concessionChecked])

  const fetchFeeTypes = async () => {
    try {
      const res = await axios.get(
        `${GetFeeMaster}/${storedBranchId}/${BoardingYear}`,
      )
      setFeeTypes(res.data)
    } catch (err) {
      toast.error('Failed to load fee types')
    }
  }

  useEffect(() => {
    fetchPendingInterviewsList()
  }, [])

  const fetchPendingInterviewsList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${pendingInterviewListAPIURL}`)

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        document_approval_date : item.documents.document_approval_date || "-",
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  const handleSaveInterviewResult = async () => {
    if (!interviewStatus) {
      toast.warning('Please select interview status')
      return
    }

    if (interviewStatus === '3' && !failReason.trim()) {
      toast.warning('Please enter fail reason')
      return
    }

    try {
      setSaveLoading(true)

      const payload = {
        reg_id: selectedRecord.reg_id,
        interview_status: Number(interviewStatus), // 2=Pass, 3=Fail
        fail_reason: failReason,
      }

      console.log(payload)

      const res = await axios.put(pendingInterviewListPassFailAPIURL, payload)
      if (res.data != null) {
        if (concessionChecked == true) {
          if (!selectedFeeId || !concessionAmount) {
            toast.warning('Please fill concession details')
            return
          }

          await applyFeeConcession()
        }

        toast.success('Interview result saved successfully')

        setViewModalOpen(false)
        setConcessionAmount('')
        setConcessionRemark('')
        setInterviewStatus('')
        setFailReason('')

        fetchPendingInterviewsList()
      }
    } catch (error) {
      toast.error('Failed to save interview result')
    } finally {
      setSaveLoading(false)
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
     { title: 'Document Approve Date', dataIndex: 'document_approval_date' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setConfirmChecked(false)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const applyFeeConcession = async () => {
    const payload = {
      branch_id: Number(storedBranchId),
      fee_id: Number(selectedFeeId),
      reg_id: Number(selectedRecord.reg_id),
      concession_remark: concessionRemark,
      concession_amount: Number(concessionAmount),
      year: Number(BoardingYear),
      fee_concession_flag: 1,
      // interview_status: 1,
      // interview_date1: selectedRecord.interviewDate1.format('YYYY-MM-DD'),
      // interview_date2: selectedRecord.interviewDate2.format('YYYY-MM-DD'),
    }

    return axios.post(StudentFeeConcession, payload)
  }

  useEffect(() => {
    if (concessionChecked && feeTypes.length > 0) {
      const hostelFee = feeTypes.find((fee) => fee.fee_name === 'Hostel Fee')

      if (hostelFee) {
        setSelectedFeeId(hostelFee.fee_id)

        const amount =
          hostelFee?.feeAmounts?.length > 0
            ? hostelFee.feeAmounts[0].fee_amount
            : 0

        setFeeAmount(amount)
      }
    }
  }, [concessionChecked, feeTypes])

  const handleFeeChange = (e) => {
    const feeId = Number(e.target.value)
    setSelectedFeeId(feeId)

    const selectedFee = feeTypes.find((f) => f.fee_id === feeId)

    const amount =
      selectedFee?.feeAmounts?.length > 0
        ? selectedFee.feeAmounts[0].fee_amount
        : 0

    setFeeAmount(amount)
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }

  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Full Name': item.full_name,
      'WhatsApp No': item.whats_no,
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [{ wch: 8 }, { wch: 35 }, { wch: 20 }]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Pending Interviews')

    XLSX.writeFile(workbook, 'Pending_Interviews_List.xlsx')
  }
  
  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Pending Interviews List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ======Modal======= */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => setViewModalOpen(false)}
        footer={null}
        width={1000}
      >
        {selectedRecord && (
          <div className="py-3 px-md-3">
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Interview Details
            </h3>

            <div
              className="border rounded shadow p-3"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* PERSONAL */}
              <h6 style={titleText}>- Personal Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                
                <div className="col-12 col-md-3">
                  <img
                    src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                    alt="Profile Picture"
                    className="rounded-circle img-fluid rounded border"
                    style={{
                      width: '160px',
                      height: '160px',
                      objectFit: 'contain',
                      display: 'block',
                      }}
                    />
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Full Name:</span>
                    <br />
                    {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                    {selectedRecord.s_lname}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Date of Birth:</span>
                    <br />
                    {selectedRecord.date_of_birth}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Blood Group:</span>
                    <br />
                    {selectedRecord.blood_grp}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mobile:</span>
                    <br />
                    {selectedRecord.mobile}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>WhatsApp No:</span>
                    <br />
                    {selectedRecord.wh_mobile}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Email:</span>
                    <br />
                    {selectedRecord.email}
                  </div>

                  <div className="col-md-12 mb-3">
                    <span style={labelCss}>Address:</span>
                    <br />
                    {selectedRecord.address}, {selectedRecord.village}, PIN -{' '}
                    {selectedRecord.pin}
                  </div>
                </div>
              </div>

              {/* ACADEMIC */}
              <h6 style={titleText}>- Academic Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Last Attended College</span>
                    <br />
                    {selectedRecord.last_attended_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Highest Qualification</span>
                    <br />
                    {selectedRecord.highest_qualification}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Degree</span>
                    <br />
                    {selectedRecord.specific_degree}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Percentage</span>
                    <br />
                    {selectedRecord.aggre_percentage} %
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Course Name</span>
                    <br />
                    {selectedRecord.course_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Passing Month / Year</span>
                    <br />
                    {selectedRecord.month_year_of_passing}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Current College</span>
                    <br />
                    {selectedRecord.curr_yr_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Total Duration</span>
                    <br />
                    {selectedRecord.total_course_duration}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Remaining Duration</span>
                    <br />
                    {selectedRecord.remaining_course_duration}
                  </div>
                </div>
              </div>

              {/* FAMILY */}
              <h6 style={titleText}>- Family Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <span style={labelCss}>Father</span>
                    <br />
                    {selectedRecord.father_fname} {selectedRecord.father_mname}{' '}
                    {selectedRecord.father_lname}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Father Mobile</span>
                    <br />
                    {selectedRecord.father_mob}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Occupation</span>
                    <br />
                    {selectedRecord.father_occ}
                  </div>

                  <div className="col-md-6 mb-3">
                    <span style={labelCss}>Mother</span>
                    <br />
                    {selectedRecord.mother_fname} {selectedRecord.mother_mname}{' '}
                    {selectedRecord.mother_lname}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Mother Mobile</span>
                    <br />
                    {selectedRecord.mother_mob}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Occupation</span>
                    <br />
                    {selectedRecord.mother_occ}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Family Members</span>
                    <br />
                    {selectedRecord.total_family_mamber}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Emergency Contact</span>
                    <br />
                    {selectedRecord.emergency_contact}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Emergency Name</span>
                    <br />
                    {selectedRecord.emergency_name}
                  </div>
                </div>
              </div>

              {/* REFERENCE */}
              <h6 style={titleText}>- Reference Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-4">
                    <span style={labelCss}>Chairman Name</span>
                    <br />
                    {selectedRecord.chairman_name}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Chairman Mobile</span>
                    <br />
                    {selectedRecord.chairman_mob}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Chairman Village</span>
                    <br />
                    {selectedRecord.chairman_village}
                  </div>

                  <div className="col-md-4 mt-3">
                    <span style={labelCss}>Reference Name</span>
                    <br />
                    {selectedRecord.reference_name}
                  </div>

                  <div className="col-md-4 mt-3">
                    <span style={labelCss}>Reference Mobile</span>
                    <br />
                    {selectedRecord.reference_mobile}
                  </div>

                  <div className="col-md-4 mt-3">
                    <span style={labelCss}>Relation</span>
                    <br />
                    {selectedRecord.reference_relation}
                  </div>
                </div>
              </div>

              {/* LOCAL GUARDIAN */}
              <h6 style={titleText}>- Local Guardian Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-4">
                    <span style={labelCss}>Name</span>
                    <br />
                    {selectedRecord.local_guardian_name}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Mobile</span>
                    <br />
                    {selectedRecord.local_guardian_mobile}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Address</span>
                    <br />
                    {selectedRecord.local_guardian_address}
                  </div>
                </div>
              </div>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="d-flex align-items-center mb-3 mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    style={{ border: '1px solid black' }}
                    checked={concessionChecked}
                    onChange={(e) => {
                      setConcessionChecked(e.target.checked)
                      if (e.target.checked == false) {
                        setConcessionAmount('')
                        setConcessionRemark('')
                      }
                    }}
                  />
                  <label style={{ fontSize: '15px', fontWeight: '500' }}>
                    Apply fee concession for this student
                  </label>
                </div>

                {concessionChecked && (
                  <div>
                    <h6 style={{ fontWeight: 600, color: '#235784' }}>
                      Fee Concession Details
                    </h6>

                    <div className="row m-0">
                      {/* Fee Type */}
                      <div className="col-md-4 mb-3">
                        <label className="form-label fw-semibold">
                          Fee Type
                        </label>
                        <select
                          className="form-select"
                          // disabled
                          value={selectedFeeId}
                          onChange={handleFeeChange}
                        >
                          <option value="">Select Fee Type</option>
                          {feeTypes.map((fee) => (
                            <option key={fee.fee_id} value={fee.fee_id}>
                              {fee.fee_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Fee Amount (Auto Filled) */}
                      <div className="col-md-4 mb-3">
                        <label className="form-label fw-semibold">
                          Fee Amount
                        </label>
                        <Input
                          value={feeAmount}
                          readOnly
                          style={{ backgroundColor: '#e6e6e6ff' }}
                        />
                      </div>

                      {/* Concession Amount */}
                      <div className="col-md-4 mb-3">
                        <label className="form-label fw-semibold">
                          Concession Amount
                        </label>

                        <Input
                          value={concessionAmount}
                          placeholder="Enter concession amount"
                          maxLength={7}
                          onChange={(e) => {
                            // ✅ allow only numbers
                            const value = e.target.value.replace(/[^0-9]/g, '')
                            setConcessionAmount(value)
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault()
                            }
                          }}
                        />
                      </div>

                      {/* Remark */}
                      <div className="col-12 mb-3">
                        <label className="form-label fw-semibold">Remark</label>
                        <Input.TextArea
                          rows={2}
                          value={concessionRemark}
                          onChange={(e) => setConcessionRemark(e.target.value)}
                          placeholder="Enter remark"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div>
                  <h6
                    style={{
                      fontWeight: 600,
                      color: '#235784',
                      marginBottom: '15px',
                    }}
                  >
                    Interview Result
                  </h6>

                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">
                        Interview Status
                      </label>

                      <select
                        className="form-select"
                        value={
                          interviewStatus ||
                          (selectedRecord?.interview_status
                            ? String(selectedRecord.interview_status)
                            : '')
                        }
                        onChange={(e) => {
                          setInterviewStatus(e.target.value)

                          if (e.target.value !== '3') {
                            setFailReason('')
                          } else if (e.target.value == '3') {
                            setConcessionChecked(false)
                            setConcessionAmount('')
                            setConcessionRemark('')
                          }
                        }}
                      >
                        <option value="">Select Status</option>
                        <option value="2">Pass</option>
                        <option value="3">Fail</option>
                      </select>
                    </div>

                    {(interviewStatus === '3' ||
                      (!interviewStatus &&
                        String(selectedRecord?.interview_status) === '3')) && (
                      <div className="col-md-8 mb-3">
                        <label className="form-label fw-semibold">
                          Fail Reason
                        </label>

                        <Input.TextArea
                          rows={3}
                          value={
                            failReason || selectedRecord?.fail_reason || ''
                          }
                          onChange={(e) => setFailReason(e.target.value)}
                          placeholder="Enter reason for failure"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/**-----------APPROVE/REJECT SECTION-----------------*/}

              <div className="mt-4 p-3">
                {/* Confirm Checkbox */}
                <div className="d-flex align-items-center mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    style={{ border: '1px solid black' }}
                    checked={confirmChecked}
                    onChange={(e) => setConfirmChecked(e.target.checked)}
                  />
                  <label style={{ fontSize: '15px', fontWeight: '500' }}>
                    I confirm all details are checked and verified
                  </label>
                </div>

                {/* Buttons */}
                <div className="d-flex gap-3 mt-3">
                  <Button
                    disabled={!confirmChecked}
                    type="primary"
                    loading={saveLoading}
                    onClick={handleSaveInterviewResult}
                  >
                    Save
                  </Button>
                  <Button
                    disabled={!confirmChecked}
                    onClick={() => {
                      setViewModalOpen(false)
                      setInterviewStatus('')
                      setFailReason('')
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default PendingInterviewList
